import { render, staticRenderFns } from "./JCB.vue?vue&type=template&id=088f587c"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088f587c')) {
      api.createRecord('088f587c', component.options)
    } else {
      api.reload('088f587c', component.options)
    }
    module.hot.accept("./JCB.vue?vue&type=template&id=088f587c", function () {
      api.rerender('088f587c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/paymentCards/JCB.vue"
export default component.exports